module.exports = __webpack_public_path__ + "img/stock1.804d6d9a.png";